import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTimer } from 'react-timer-hook';
import { updateData } from '../redux/roundtoSlice';

function MyCountdownTimer({ }) {


    const state = useSelector((state) => Number(state.roundData?.duration))
    const dispatch = useDispatch()



    const expiryTimestamp = new Date();
    expiryTimestamp.setMinutes(expiryTimestamp.getMinutes() + state);

    const {
        seconds,
        minutes,
        hours,
        isRunning,
    } = useTimer({
        expiryTimestamp,
        onExpire: () => {
            dispatch(updateData({ field: 'isTimeUp', value: true }))
        },
    });

    useEffect(() => {
        dispatch(updateData({ field: 'duration', value: minutes }))
    }, [seconds])

    return (


        <div style={{color:state<1?'#DC2626':""}} >
            <span >{String(hours).padStart(2, '0')}:</span>
            <span>{String(minutes).padStart(2, '0')}:</span>
            <span>{String(seconds).padStart(2, '0')}</span>
        </div>


    );
}

export default MyCountdownTimer;